import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NgStepperModule } from 'angular-ng-stepper';
import { ChatRoutingModule } from './chat-routing.module';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { SharedModule } from '../../shared/shared.module';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@NgModule({
    //declarations: [ChatMessageComponent],
    imports: [
        CommonModule,
        ChatRoutingModule,
        SharedModule,
        LayoutModule,
        ButtonsModule,
        NgSelectModule,
        NgStepperModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class ChatModule { }
